/** Gross shift span in hours from start/end clock times minus break. */
export function calcShiftDurationHours(startTime, endTime, breakMinutes = 0) {
  if (!startTime || !endTime) return 0;
  const [sh, sm] = startTime.split(":").map(Number);
  const [eh, em] = endTime.split(":").map(Number);
  let startM = sh * 60 + (sm || 0);
  let endM = eh * 60 + (em || 0);
  if (endM <= startM) endM += 24 * 60;
  const mins = Math.max(0, endM - startM - (Number(breakMinutes) || 0));
  return Math.round((mins / 60) * 100) / 100;
}

export function isOvernightShift(startTime, endTime) {
  if (!startTime || !endTime) return false;
  const [sh, sm] = startTime.split(":").map(Number);
  const [eh, em] = endTime.split(":").map(Number);
  const startM = sh * 60 + (sm || 0);
  const endM = eh * 60 + (em || 0);
  return endM <= startM;
}

export function formatTime12(t) {
  if (!t) return "—";
  const [h, m] = t.split(":").map(Number);
  const am = h < 12;
  const hr = h % 12 || 12;
  return `${hr}:${String(m || 0).padStart(2, "0")} ${am ? "AM" : "PM"}`;
}

export function employeeDisplayName(emp) {
  if (!emp) return "";
  return (
    emp.display_name ||
    [emp.first_name, emp.last_name].filter(Boolean).join(" ") ||
    emp.employee_code ||
    ""
  );
}

export function employeeLabel(emp) {
  const code = emp.employee_code || "—";
  const name = employeeDisplayName(emp);
  const dept = emp.department?.name;
  const desig = emp.designation?.title;
  const meta = [dept, desig].filter(Boolean).join(" · ");
  return { primary: `${code} — ${name}`, secondary: meta };
}

export function datesInPeriod(periodStart, periodEnd) {
  const out = [];
  const cur = new Date(periodStart + "T00:00:00");
  const end = new Date(periodEnd + "T00:00:00");
  while (cur <= end) {
    out.push(cur.toISOString().slice(0, 10));
    cur.setDate(cur.getDate() + 1);
  }
  return out;
}

export function exportAssignmentsCsv(rows) {
  const headers = [
    "Employee",
    "Code",
    "Department",
    "Date",
    "Shift",
    "Timing",
    "Status",
    "Notes",
  ];
  const lines = [headers.join(",")];
  rows.forEach((r) => {
    lines.push(
      [
        r.employee_name,
        r.employee_code,
        r.department,
        r.work_date,
        r.shift_name,
        r.shift_timing,
        r.status,
        (r.notes || "").replace(/"/g, '""'),
      ]
        .map((c) => `"${c ?? ""}"`)
        .join(",")
    );
  });
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `roster-assignments-${Date.now()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function shiftColor(code) {
  const palette = {
    MORNING: "bg-amber-100 text-amber-900 border-amber-200",
    EVENING: "bg-indigo-100 text-indigo-900 border-indigo-200",
    NIGHT: "bg-violet-100 text-violet-900 border-violet-200",
    OFF: "bg-slate-100 text-slate-600 border-slate-200",
  };
  return palette[code] || "bg-teal-50 text-teal-900 border-teal-200";
}
